module.exports = __webpack_public_path__ + "media/application/images/svgs/key-ba0b00784de64bfd8d4bba183b65dee0.svg";